import { motion } from "framer-motion";

const EASE = [0.16, 1, 0.3, 1];

export const Reveal = ({ children, delay = 0, y = 28, className = "" }) => (
  <motion.div
    className={className}
    initial={{ opacity: 0, y }}
    whileInView={{ opacity: 1, y: 0 }}
    viewport={{ once: true, margin: "-70px" }}
    transition={{ duration: 0.75, delay, ease: EASE }}
  >
    {children}
  </motion.div>
);

export const SectionHead = ({ overline, title, sub, dark = false, align = "left" }) => (
  <Reveal>
    <div className={align === "center" ? "mx-auto max-w-2xl text-center" : "max-w-2xl"}>
      <p
        className={`flex items-center gap-3 text-xs font-semibold uppercase tracking-[0.25em] text-brand-gold sm:text-sm ${
          align === "center" ? "justify-center" : ""
        }`}
      >
        <span className="h-px w-8 bg-brand-gold" />
        {overline}
        {align === "center" && <span className="h-px w-8 bg-brand-gold" />}
      </p>
      <h2
        className={`mt-4 font-serif text-3xl font-bold tracking-tight sm:text-4xl lg:text-5xl ${
          dark ? "text-brand-cream" : "text-brand-ink"
        }`}
      >
        {title}
      </h2>
      {sub && (
        <p className={`mt-4 text-base sm:text-lg ${dark ? "text-brand-cream/70" : "text-brand-mute"}`}>
          {sub}
        </p>
      )}
    </div>
  </Reveal>
);
